import Reveal from "@/components/Reveal";

const HOME_IMG =
  "https://images.unsplash.com/photo-1701817822150-2d218d8610e6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwxfHxjYWxtJTIwaG9tZSUyMGludGVyaW9yfGVufDB8fHx8MTc5MjE1MDY5N3ww&ixlib=rb-4.1.0&q=85";

const STEPS = [
  { n: "1", title: "Primo contatto", desc: "Mi chiami o mi scrivi: ascolto il tuo problema e fissiamo la prima valutazione, spesso entro 48 ore." },
  { n: "2", title: "Valutazione a domicilio", desc: "Anamnesi completa e test funzionali nel tuo ambiente quotidiano, dove il recupero avviene davvero." },
  { n: "3", title: "Piano condiviso", desc: "Definiamo insieme obiettivi concreti e misurabili: sai sempre dove siamo e dove vogliamo arrivare." },
  { n: "4", title: "Trattamento e recupero", desc: "Sedute regolari con progressi monitorati: adattiamo il percorso fino al raggiungimento degli obiettivi." },
];

export default function HowItWorks() {
  return (
    <section id="come-funziona" data-testid="how-it-works-section" className="py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-14">
        <div className="lg:col-span-5">
          <Reveal className="lg:sticky lg:top-28">
            <p className="text-xs font-bold uppercase tracking-[0.22em] text-terracotta mb-4">Come funziona</p>
            <h2 className="font-serif tracking-tight text-pine text-3xl sm:text-4xl lg:text-5xl">
              Dalla chiamata al recupero, in quattro passi.
            </h2>
            <div className="relative mt-10 hidden lg:block">
              <div className="absolute -top-5 -left-5 w-full h-full bg-sage/40 rounded-md" aria-hidden="true" />
              <img
                src={HOME_IMG}
                alt="Interno di casa luminoso e accogliente"
                data-testid="how-it-works-image"
                className="relative w-full aspect-[4/3] object-cover rounded-md"
              />
            </div>
          </Reveal>
        </div>
        <div className="lg:col-span-7">
          {STEPS.map((s, i) => (
            <Reveal key={s.n} delay={i * 0.08}>
              <div data-testid={`step-${s.n}`} className="flex gap-6 lg:gap-10 border-l-2 border-sand pl-6 lg:pl-10 pb-12 lg:pb-16 relative">
                <span className="absolute -left-[9px] top-1 w-4 h-4 rounded-full bg-terracotta" aria-hidden="true" />
                <span className="font-serif text-5xl lg:text-6xl text-sand leading-none">{s.n}</span>
                <div>
                  <h3 className="font-serif text-2xl lg:text-3xl text-pine tracking-tight">{s.title}</h3>
                  <p className="mt-3 text-sm lg:text-base text-moss leading-relaxed max-w-md">{s.desc}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
